export const SURVEY_DATA = [
  {
    num: "Q1",
    text: "프로그램은<br/>전반적으로 즐거우셨나요?",
    type: "single",
    options: [
      "5점: 매우 즐거웠습니다.",
      "4점: 적당히 즐거웠습니다.",
      "3점: 평범했습니다.",
      "2점: 그저 그랬습니다.",
      "1점: 별로였습니다.",
    ],
  },
  {
    num: "Q2",
    text: "미션의 난이도는<br/>적절했나요?",
    type: "single",
    options: [
      "5점: 매우 적절했습니다.",
      "4점: 적당한 느낌입니다.",
      "3점: 잘 모르겠습니다.",
      "2점: 조금 어려웠습니다.",
      "1점: 매우 어려웠습니다.",
    ],
  },
  {
    num: "Q3",
    text: "오늘 미션을 함께 하며<br/>팀원과 협력이 잘 이루어졌나요?",
    type: "single",
    options: [
      "5점: 매우 잘 되었습니다.",
      "4점: 괜찮았습니다.",
      "3점: 보통이었습니다.",
      "2점: 조금 어려웠습니다.",
      "1점: 매우 어려웠습니다.",
    ],
  },
  {
    num: "Q4",
    text: "프로그램 참여 후<br/>기분이 어떻게 변화했나요?",
    type: "single",
    options: [
      "5점: 매우 좋습니다.",
      "4점: 매우 아쉽습니다.",
      "3점: 보통이었습니다.",
      "2점: 그저 그랬습니다.",
      "1점: 매우 아쉽습니다.",
    ],
  },
  {
    num: "Q5",
    text: "오늘 프로그램에서 가장<br/>인상 깊었던 요소를 골라주세요.<br/><small>(중복 선택 가능)</small>",
    type: "multi",
    options: [
      "미션 내용 ∙ 스토리",
      "팀원과의 협동 순간",
      "경쟁 · 점수 체계",
      "새로운 공간과 분위기",
      "진행 방식 · 운영",
    ],
  },
  {
    num: "Q6",
    text: "아쉬웠거나 개선되었으면<br/>하는 점이 있다면 알려주세요.",
    type: "text",
  },
  {
    num: "Q7",
    text: "이 프로그램을 동료나 지인에게<br/>추천하고 싶으신가요?",
    type: "single",
    options: [
      "5점: 강력 추천하고 싶어요!",
      "4점: 관련 일을 하는 분께 알려줄래요~",
      "3점: 추천해도 좋을 것 같아요~",
      "2점: 고민해볼게요.",
      "1점: 추천하고 싶지 않아요.",
    ],
  },
];
